
<h3>Asignar sobreturno hoy</h3>
<div fxLayout="row" fxLayoutWrap="wrap">
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
        <mat-card>
            <mat-card-content>
                <h4>Datos personales</h4>
                <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="space-evenly center">
                    <mat-form-field fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
                        <input matInput placeholder="Nº Documento" maxlength="9" [(ngModel)]="docNumber" name="docNumber" onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;">
                    </mat-form-field>
                    <mat-radio-group fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50" fxLayoutAlign="space-evenly center"
                        [(ngModel)]="gender" name="gender">
                        <mat-radio-button value="M">Masculino</mat-radio-button>
                        <mat-radio-button value="F">Femenino</mat-radio-button>
                    </mat-radio-group>
                    <div fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20" fxLayoutAlign="center">
                        <button mat-mini-fab mat-raised-button color="primary"
                            (click)="searchApplicant(docNumber, gender)">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
        <mat-card fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" *ngIf="person">
            <mat-card-content fxLayout="column" fxLayoutWrap="wrap" fxFlex.gt-sm="90" fxFlex.gt-xs="90" fxFlex="90"
                style="padding: 14px; margin-bottom: 0px;">
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                    <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30" fxLayoutAlign="space-evenly center">
                        <img style="height: 64px" *ngIf="person.base64Picture"
                        [src]="'data:image;base64,' + person.base64Picture | imagePipe" />
                    </div>
                    <div fxFlex.gt-sm="70" fxFlex.gt-xs="70" fxFlex="70">
                        <div style="width:100%">{{person.lastName}}, {{person.firstName}}
                        </div>
                        <div style="width:100%">
                            DNI: {{person.docNumber}}
                        </div>
                        <div style="width:100%">
                            Fecha de Nacimiento: {{person.birthDate | date:'dd/MM/yyyy'}}
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutWrap="wrap" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100"
                    fxLayoutAlign="space-around center">
                    <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
                        <mat-form-field>
                            <mat-label>Código de área</mat-label>
                            <input matInput name="codeNumber" (blur)="validPhoneNumber()"
                                [maxlength]="codeNumbermaxlength" [(ngModel)]="person.codeNumber" required>
                        </mat-form-field>
                    </div>
                    <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
                        <mat-form-field>
                            <mat-label>Número</mat-label>
                            <input matInput name="phoneNumber" [maxlength]="phoneNumbermaxlength" (blur)="validPhoneNumber()"
                                [(ngModel)]="person.phoneNumber" required>
                        </mat-form-field>
                    </div>
                    <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <input matInput name="email" (blur)="validEmail()" [(ngModel)]="person.email">
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
            <div fxFlex.gt-sm="10" fxFlex.gt-xs="10" fxFlex="10" fxLayoutAlign="end start">
                <button fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20" mat-button style="margin: 10px 10px 0 0;"
                    (click)="close()">
                    <i class="material-icons">close</i>
                </button>
            </div>
        </mat-card>
    </div>
</div>



<div fxLayout="row" fxLayoutWrap="wrap">
    <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <h4>Trámite</h4>
                <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start center">
                    <div fxLayout="row" fxLayoutAlign="center center" fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                        <span fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20">
                            Trámite
                        </span>
                        <mat-form-field fxFlex.gt-sm="40" fxFlex.gt-xs="40" fxFlex="40">
                            <mat-select name="sectionalTypeId" [(ngModel)]="sectionalType.id"
                                (ngModelChange)="getSectionalItemsBySectionalType(sectionalType.id)">
                                <mat-option *ngFor="let type of sectionalTypes" [value]="type.id">
                                    {{ type.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20" style="margin-left: 8px;"
                            *ngIf="sectionalItems && sectionalItems.length > 1">
                            <mat-form-field>
                                <mat-select placeholder="Tipo de trámite" name="sectionalItemId" [(ngModel)]="sectionalItem"
                                    (ngModelChange)="getStampBySectionalItem(sectionalItem.id)">
                                    <mat-option *ngFor="let item of sectionalItems" [value]="item">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                        <ng-container *ngIf="stampTypes && stampTypes.length > 0">
                            <span fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20">
                                Tipo de sellado
                            </span>
                            <mat-form-field fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                                <mat-select name="stampTypeId" [(ngModel)]="stampType.id">
                                    <mat-option *ngFor="let stamp of stampTypes" [value]="stamp.id">
                                        {{ stamp.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>
                    </div>
                </div>
                <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start center"
                    *ngIf="stampType && stampType.id">
                    <div fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20">
                        Ingrese códigos de sellados:
                    </div>
                    <mat-form-field fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
                        <input matInput placeholder="Número de transacción" [(ngModel)]="transactionNumber" maxlength="10"
                            name="transaction"  onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;">
                    </mat-form-field>&nbsp;&nbsp;
                    <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="end center">
                        <mat-form-field fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30" fxLayoutAlign="center center">
                            <input matInput placeholder="Número de control" [(ngModel)]="controlNumber" maxlength="15"
                                name="controlNumber">
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div fxLayout="row" fxLayoutWrap="wrap" fxLayoutAlign="center center" style="margin-bottom: 20px;">
    <button  (click)="closeDialog()" mat-raised-button color="warn" >Cancelar</button> &nbsp;&nbsp;
    <button  (click)="sendAppointment()" mat-raised-button color="primary"
        >Enviar solicitud de turno</button>
</div>
